export default __webpack_public_path__ + "static/media/green.68082cd3.svg";